<header *ngIf="!isModal" class="ac-header">
	<section class="grid {{ gridClass }}">
		<section class="row dz-row justify-content-left"><h2 class="col-24 dz-col text-16-bold" dcrHTMLKey="APP_HEADER_TITLE">APP_HEADER_TITLE</h2></section>
	</section>
</header>

<section class="new-analysis-dialog grid {{ gridClass }}">
	<ng-container *ngIf="useAladdinBranding && !isModal; else noBranding">
		<section class="margin-top-40">
			<div class="text-28-extra-bold" dcrHTMLKey="NEW_ANALYSIS_WELCOME_TITLE">NEW_ANALYSIS_WELCOME_TITLE</div>
			<div class="row dz-row pba">
				<div class="col-20 dz-col-20 text-16 subtitle-with-branding" [ngClass]="{ 'text-20-bold': isModal }" dcrHTMLKey="NEW_ANALYSIS_WELCOME_SUB_TITLE">
					To start a new analysis, choose from the options below
				</div>
				<div class="col-4 dz-col-4">
					<img ada-decorative [remote-src]="'Powered_By_Aladdin.svg'" class="pba-img padding-bottom-10" />
				</div>
			</div>
		</section>
	</ng-container>
	<ng-template #noBranding>
		<section class="text-align-center margin-top-40">
			<div *ngIf="!isModal" class="text-28-extra-bold" dcrHTMLKey="NEW_ANALYSIS_WELCOME_TITLE">NEW_ANALYSIS_WELCOME_TITLE</div>
			<div class="subtitle text-16 margin-top-10" [ngClass]="{ 'text-20-bold': isModal }" dcrHTMLKey="NEW_ANALYSIS_WELCOME_SUB_TITLE">
				To start a new analysis, choose from the options below
			</div>
		</section>
	</ng-template>
	<section class="row dz-row tile-margin">
		<section class="tile tile-left dz-col-12 col-12">
			<div class="d-inline-block dz-inline-block pull-right padding-right-50">
				<div class="text-align-center margin-standard"><img ada-decorative [remote-src]="'icon_savedportfolios.svg'" /></div>
				<div class="main-header text-12 text-md-12 text-sm-12" dcrHTMLKey="PORTFOLIO_TITLE_SMALL">START WITH A</div>
				<div class="sub-header text-20-bold text-md-14-bold text-sm-12-bold" dcrHTMLKey="PORTFOLIO_TITLE_MAIN">Saved Portfolio</div>
				<div class="description text-16" dcrHTMLKey="PORTFOLIO_DESCRIPTION">Choose one of your already saved portfolios to analyze and optimize.</div>
				<div class="btn-container">
					<button
						dz-button
						[track-event]="analyticsAppKey + ' saved portfolios:body button:my portfolios'"
						(click)="openPortfolioTable()"
						dcrHTMLKey="PORTFOLIO_BUTTON"
						data-cy="saved-portfolios-button">
						My Portfolios
					</button>
				</div>
			</div>
		</section>
		<section class="tile tile-right dz-col-12 col-12">
			<div class="d-inline-block dz-inline-block pull-left padding-left-50">
				<div class="text-align-center margin-standard"><img ada-decorative [remote-src]="'icon_createnew.svg'" /></div>
				<div class="main-header text-12 text-md-12 text-sm-12" dcrHTMLKey="CREATE_TITLE_SMALL">CREATE A</div>
				<div class="sub-header text-20-bold text-md-14-bold text-sm-12-bold" dcrHTMLKey="CREATE_TITLE_MAIN">New Portfolio</div>
				<div class="description text-16" dcrHTMLKey="CREATE_DESCRIPTION">Start from scratch. Enter tickers and weights or import from a spreadsheet.</div>
				<div class="btn-container">
					<button
						dz-button
						[track-event]="analyticsAppKey + ' saved portfolios:body button:create new'"
						(click)="directToPortfolioEditor()"
						dcrHTMLKey="CREATE_BUTTON"
						data-cy="create-new-portfolio-button">
						Create New
					</button>
				</div>
			</div>
		</section>
	</section>
</section>
